import React from 'react';
import { getLocationParam } from 'js/utils/url.util';

import { isJoinButtonAvailable } from '../../heplers';
import CircularButton from '../CircularButton';
import JoinButton from '../JoinButton';

import style from './index.scss';

const closeButton = () => {
    const searchResult = getLocationParam('showCloseButton');
    return searchResult === 'true' || searchResult === '1';
};

const joinLeaveButton = details => isJoinButtonAvailable(details) && !details.joined;

const shouldRender = details => closeButton() || joinLeaveButton(details);

export default ({ ...details }) => (
    <>
        {shouldRender(details) &&
        <>
            <span className={style.bottomMargin} />
            <div className={style.overlay}>
                <div className={style.actions}>
                    {closeButton() && <CircularButton character={'\u00D7'}
                        className={joinLeaveButton(details) ? `${style.spaceRight}` : ''} />}
                    {joinLeaveButton(details) && <JoinButton {...details} className={style.wideButton} />}
                </div>
            </div>
        </>
        }
    </>
);
